/**
 * @fileoverview 画面に出すサービス名の出し分け
 * @description 「カツオ勤怠」は営業・デモ用の名義。実顧客のテナントに出してはいけない。
 *   全社が同じフロントビルドを共有しているため、表示名とログイン画像はホスト名で切り替える。
 *   （2026-08-27: 実顧客の管理サイトに「カツオ勤怠」表記とデモ用イラストが出ていたため追加）
 */

/** デモ・検証用のサブドメイン。ここだけ「カツオ勤怠」名義で表示する */
/** portal はカツオポータルの開発テスト用会社、portal-test はその体験デモ（2026-10-20追加） */
const DEMO_SUBDOMAINS = ['test', 'test-kaisya', 'portal', 'portal-test'];

/** いま開いているホストがデモ環境か */
export function isDemoHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  // localhost や IP 直打ちの開発環境は実顧客と同じ（中立）表示にする
  if (host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return false;
  const first = host.split('.')[0] ?? '';
  return DEMO_SUBDOMAINS.includes(first);
}

const DEMO = isDemoHost();

/** サイドバー等に出すサービス名 */
export const BRAND_NAME = DEMO ? 'カツオ勤怠' : 'CATMS';
/** サービス名の下に添える小さい文字 */
export const BRAND_SUB = DEMO ? '船員勤怠クラウド' : 'Admin Console';
/** ログイン画面の左パネルの画像 */
export const LOGIN_ART = DEMO ? '/ship-demo.png' : '/ship.png';
/** ログイン画面の英字サブタイトル */
export const LOGIN_SUBTITLE = DEMO
  ? 'Seafarer Attendance & Workforce Cloud'
  : 'Crew Attendance & Track Management System';
